var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAirportIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38323 5.53231L1.38179 5.53291C1.2006 5.606 1.10571 5.80602 1.16392 5.99262C1.22229 6.17984 1.41487 6.29053 1.60601 6.24672L6.99474 5.01176L5.865 6.51225C5.78293 6.62126 5.78361 6.77162 5.86665 6.8799C5.9497 6.98814 6.09475 7.02779 6.22137 6.9767L7.29648 6.54314C7.32734 6.53071 7.35596 6.51327 7.3812 6.49148L10.7194 3.61472L14.6508 2.02154C16.1421 1.39366 16.0344 0.790342 15.9659 0.620442C15.9127 0.488699 15.7832 0.306439 15.4679 0.186322C15.1481 0.0644755 14.7037 0.0289818 14.1094 0.0778584C13.911 0.0941504 13.8036 0.0808377 13.6899 0.0667436C13.2903 0.0172236 13.0159 0.0179431 11.5988 0.589393L3.84831 3.71524L1.12867 1.95424C1.02611 1.88785 0.897674 1.87553 0.784327 1.92129L0.27786 2.12557C0.173607 2.16761 0.093703 2.25417 0.0601151 2.36144C0.0265232 2.46875 0.0428034 2.58545 0.104435 2.67939L1.85319 5.34523L1.38323 5.53231Z",
    fill: "#262626"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.285 9.16406H1.24606C0.851288 9.16406 0.53125 9.48419 0.53125 9.87887C0.53125 10.2736 0.851288 10.5937 1.24606 10.5937H15.285C15.6798 10.5937 15.9998 10.2736 15.9998 9.87887C15.9998 9.48406 15.6798 9.16406 15.285 9.16406Z",
    fill: "#262626"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportIcon);
export default __webpack_public_path__ + "static/media/airport-icon.9513158fb580ad01fe5b9e73a65b6963.svg";
export { ForwardRef as ReactComponent };